import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Buscás videos sueltos en YouTube que no siguen ningún orden lógico', 'Aprendés señas sueltas pero no sabés cómo armar frases reales', 'El material que encontrás no está adaptado al LSA argentino', 'La gramática visual del LSA nunca te la explicó nadie de manera clara', 'Cada vez que estás frente a una persona sorda, te bloqueás', 'Empezás a aprender, lo dejás, volvés a empezar desde cero'];
  return <section className="py-20 bg-white" data-id="element-234">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-235">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-236">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6 text-balance" data-id="element-237">
            ¿Cuántas veces más vas a quedarte en blanco frente a una persona
            sorda?
          </h2>

          <div className="space-y-6 text-lg text-slate-600 text-left md:text-center max-w-3xl mx-auto" data-id="element-238">
            <p data-id="element-239">
              Querés aprender LSA. Tal vez tenés un familiar sordo, un compañero
              de trabajo, un vecino, un alumno. O simplemente sentís que el
              mundo sería más justo si más gente pudiera comunicarse.
            </p>
            <p data-id="element-240">
              <strong data-id="element-241">
                Pero nadie te dijo que aprender LSA iba a ser tan difícil de
                encarar solo.
              </strong>
            </p>
            <p data-id="element-242">
              Videos de YouTube sin orden. Apps en inglés que no tienen nada que
              ver con Argentina. Cursos carísimos que no podés pagar o que no
              tenés tiempo de seguir. Material que no explica cómo funciona la
              gramática visual. Señas que aprendés y olvidás porque no tenés
              sistema.
            </p>
            <p className="font-bold text-xl text-slate-900 pt-4" data-id="element-243">
              No es falta de ganas. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-50 border border-red-100 rounded-2xl p-6 md:p-8" data-id="element-244">
          <ul className="space-y-4" data-id="element-245">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-246">
                <div className="mt-1 bg-red-100 p-1 rounded-full shrink-0" data-id="element-247">
                  <X className="w-4 h-4 text-red-600" data-id="element-248" />
                </div>
                <span className="text-slate-700 font-medium" data-id="element-249">{problem}</span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-250">
          <p className="text-2xl font-bold text-blue-600" data-id="element-251">
            ¿Y si este fuera el último día que te quedás sin poder comunicarte?
          </p>
        </div>
      </div>
    </section>;
}